<template>
    <section class="dp-layout">
        <section class="dp-left shadow-sm">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1" />
        </section>

        <section class="dp-right">
            <div class="glass-header shadow-sm">
                <div class="title-group">
                    <h1>每日食谱发布</h1>
                    <p class="subtitle">管理您的餐饮供应任务与批次计划</p>
                </div>
                <div class="action-group">
                    <el-input v-model="filters.date" placeholder="输入任务名称搜索" size="small" class="header-date-picker"
                        clearable @keyup.enter.native="handleSearch" style="width: 200px; margin-right: 10px;" />
                    <el-button type="info" plain icon="el-icon-search" size="small" @click="handleSearch"
                        style="margin-right: 10px;">
                        查询
                    </el-button>
                    <el-button type="primary" icon="el-icon-magic-stick" size="small" @click="handleAdd"
                        class="gradient-btn-primary">
                        创建发布批次
                    </el-button>
                </div>
            </div>

            <div class="content-wrapper">
                <div class="tbl-scroll-host">
                                <el-table height="100%" :data="recipeRecords" v-loading="listLoading" class="modern-table shadow-sm" size="medium">
                    <el-table-column prop="RecipeName" label="发布任务名称" min-width="220" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="task-info">
                                <span class="task-name">{{ scope.row.RecipeName }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="生效周期" width="220" align="center">
                        <template slot-scope="scope">
                            <span class="date-range-text">{{ scope.row.StartDate }} 至 {{ scope.row.EndDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="OrderStartTime" label="点餐时间段" min-width="280" align="center">
                        <template slot-scope="scope">
                            <div class="time-range-display">
                                <el-tag size="mini" effect="plain" type="info">{{ scope.row.OrderStartTime }}</el-tag>
                                <span class="range-sep">至</span>
                                <el-tag size="mini" effect="plain" type="danger">{{ scope.row.OrderEndTime }}</el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="200" fixed="right" align="center">
                        <template slot-scope="scope">
                            <div class="table-op-pair">
                                <el-button type="text" size="small" class="table-op-link" @click="handleEdit(scope.row)">编辑</el-button>
                                <el-button type="text" size="small" class="table-op-link table-op-link--danger"
                                    @click="handleRemove(scope.row)">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                </div>

                <div class="footer-pagination text-right mt-20">
                    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="page" :page-sizes="[10, 20, 50]" :page-size="pageSize"
                        layout="total, prev, pager, next, jumper" :total="total" style="float: right" />
                </div>
            </div>
        </section>

        <!-- 弹窗部分：极致交互重塑 -->
        <el-dialog :title="formTitle" :visible.sync="dialogVisible" width="1100px" top="5vh"
            custom-class="aesthetic-dialog" :close-on-click-modal="false">
            <div class="dialog-content">
                <!-- 核心配置栏 -->
                <div class="config-card shadow-sm" style="margin-bottom: 15px; padding: 12px 16px;">
                    <el-form :model="recipeForm" ref="recipeForm" :rules="rules" label-position="top" size="small">
                        <el-row :gutter="12">
                            <el-col :span="8">
                                <el-form-item label="任务名称" prop="RecipeName" style="margin-bottom: 0;">
                                    <el-input v-model="recipeForm.RecipeName" placeholder="例如：春季第一周营养餐谱" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="消费生效周期" prop="dateRange" style="margin-bottom: 0;">
                                    <el-date-picker v-model="recipeForm.dateRange" type="daterange"
                                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                                        style="width: 100%" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="起止点餐时间" prop="orderTimeRange"
                                    style="margin-bottom: 0; position: relative;">
                                    <el-date-picker v-model="recipeForm.orderTimeRange" type="datetimerange"
                                        start-placeholder="开启点餐时间" end-placeholder="截止点餐时间" format="yyyy-MM-dd HH:mm"
                                        value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
                                    <div class="logic-hint" v-if="orderTimeError"
                                        style="color: #f56c6c; border-color: #f56c6c; background: #fef0f0; margin-top: 5px; padding: 2px 5px; border-radius: 4px; position: absolute; top: 100%; left: 0; width: 100%; z-index: 10; font-size: 12px; line-height: 1.2;">
                                        <i class="el-icon-warning"></i> 订餐截止不可晚于消费结束日期！
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>

                <!-- 极速排餐向导组件化 -->
                <div class="wizard-container shadow-sm mt-20">
                    <div class="wizard-header">
                        <div class="header-left">
                            <h3>菜品批量编排</h3>
                            <p>点选“启动极速向导”可批量生成矩阵，或在下方手动调整</p>
                        </div>
                        <el-button type="primary" plain size="small" round @click="openWizard"
                            icon="el-icon-magic-stick">启动极速向导</el-button>
                    </div>

                    <div class="matrix-table-wrapper" v-if="dishList.length > 0">
                        <!-- 核心视觉进化：日期筛选 Tabs -->
                        <div class="matrix-tabs-bar">
                            <el-tabs v-model="activeDateTab" type="card" class="modern-tabs">
                                <el-tab-pane label="全部明细" name="all"></el-tab-pane>
                                <el-tab-pane v-for="date in dateTabs" :key="date" :label="formatTabLabel(date)"
                                    :name="date">
                                </el-tab-pane>
                            </el-tabs>
                        </div>

                        <el-table :data="filteredDishList" border size="mini" max-height="450"
                            class="matrix-table modern-table-mini">
                            <el-table-column label="就餐日期" width="110" align="center" v-if="activeDateTab === 'all'">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.RecipeDate }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Name" label="菜品名称" min-width="140" show-overflow-tooltip
                                align="center" />
                            <el-table-column label="时段" width="120" align="center">
                                <template slot-scope="scope">
                                    <el-select v-model="scope.row.DinnerTimeId" size="mini" placeholder="选时段"
                                        @change="(val) => onRowTimeChange(val, scope.row)">
                                        <el-option v-for="item in timeSlotOptions" :key="item.Id"
                                            :label="item.DinnerName" :value="item.Id" />
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="就餐时间" width="160" align="center">
                                <template slot-scope="scope">
                                    <div class="read-only-time">
                                        <i class="el-icon-time mr-5"></i>
                                        <span>{{ scope.row.DiningStartTime || '--:--' }}</span>
                                        <span class="mx-2">至</span>
                                        <span>{{ scope.row.DiningEndTime || '--:--' }}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="单价" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.DishPrice" size="mini">
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="总量" width="80" align="center">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.Quantity" size="mini" />
                                </template>
                            </el-table-column>
                            <el-table-column label="已订" width="80" align="center">
                                <template slot-scope="scope">
                                    <el-tag size="mini" type="success" effect="plain"
                                        v-if="scope.row.OrderedQuantity > 0">
                                        {{ scope.row.OrderedQuantity }}
                                    </el-tag>
                                    <span v-else style="color: #94a3b8;">0</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="档口" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.Position" placeholder="窗口号" size="mini" />
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" class="table-op-link table-op-link--danger"
                                        @click="removeDishFromList(scope.$index)">移除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="matrix-footer">
                            <span class="stats-text" v-if="activeDateTab === 'all'">
                                已为您生成 <b>{{ dishList.length }}</b> 条排餐记录
                            </span>
                            <span class="stats-text" v-else>
                                <b>{{ activeDateTab }}</b> 当天共有 <b>{{ filteredDishList.length }}</b> 条记录 (总计 {{
                                    dishList.length
                                }} 条)
                            </span>
                            <el-button type="text" size="mini" class="text-danger"
                                @click="dishList = []">清空列表</el-button>
                        </div>
                    </div>

                    <div v-else class="empty-matrix">
                        <div class="empty-content">
                            <i class="el-icon-refresh-right"></i>
                            <p>列表空空如也，请点击右上角启动向导一键生成</p>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" round>取消返回</el-button>
                <el-button type="primary" :loading="submitLoading" @click="handleSubmit" round
                    class="gradient-btn-primary px-30">
                    确认发布排餐计划
                </el-button>
            </div>
        </el-dialog>

        <!-- 极轻量排餐向导 -->
        <el-dialog title="批量向导：极速生成" :visible.sync="wizardVisible" width="600px" append-to-body
            custom-class="wizard-modal">
            <div class="wizard-form-container">
                <el-form :model="wizardForm" label-position="top" size="small">
                    <div class="wizard-section">
                        <h4 class="wizard-label"><i class="el-icon-date"></i> 第一步：确定排餐周期</h4>
                        <el-date-picker v-model="wizardForm.dateRange" type="daterange" value-format="yyyy-MM-dd"
                            style="width: 100%" :picker-options="wizardPickerOptions" />
                        <div class="wizard-logic-tip mt-5">
                            <i class="el-icon-info"></i> 仅可选主计划生效周期内的日期 ({{ recipeForm.dateRange[0] }} 至 {{
                                recipeForm.dateRange[1] }})
                        </div>
                    </div>

                    <div class="wizard-section mt-15">
                        <h4 class="wizard-label"><i class="el-icon-price-tag"></i> 第二步：勾选目标时段</h4>
                        <div class="wizard-checkbox-grid">
                            <el-checkbox-group v-model="wizardForm.selectedTimeIds">
                                <el-checkbox v-for="item in timeSlotOptions" :key="item.Id" :label="item.Id" border
                                    class="m-0 mb-5 mr-10">{{ item.DinnerName }}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>

                    <div class="wizard-section mt-15">
                        <h4 class="wizard-label"><i class="el-icon-food"></i> 第三步：选择上架菜品</h4>
                        <el-select v-model="wizardForm.selectedDishIds" multiple placeholder="请在这里点选或搜索菜品..." filterable
                            style="width: 100%" collapse-tags>
                            <el-option v-for="item in dishOptions" :key="item.Id" :label="item.Name" :value="item.Id" />
                        </el-select>
                    </div>
                </el-form>
            </div>
            <div slot="footer">
                <el-button type="primary" block @click="generateByWizard" class="gradient-btn-primary w-full"
                    icon="el-icon-magic-stick">立即铺展生成矩阵</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane'
import { getDailyRecipeList, getDailyRecipeDetail, saveDailyRecipe, deleteDailyRecipe, getDishListPage } from '../../api/modules/catering';
import { getDinnerTimeList } from '../../api/modules/consumption';

export default {
    components: { DepartmentPane },
    data() {
        return {
            departmentId: '',
            filters: { date: '' },
            recipeRecords: [],
            total: 0,
            page: 1,
            pageSize: 20,
            listLoading: false,

            activeDateTab: 'all',
            dialogVisible: false,
            submitLoading: false,
            formTitle: '发布食谱任务',
            recipeForm: {
                Id: 0,
                ReleaseId: 0,
                DepartmentId: '',
                RecipeName: '',
                dateRange: [],
                orderTimeRange: []
            },
            selectedDishIds: [],
            dishList: [],
            rules: {
                RecipeName: [{ required: true, message: '请输入计划名称', trigger: 'blur' }],
                dateRange: [{ required: true, message: '请选择生效日期', trigger: 'change' }],
                orderTimeRange: [
                    { required: true, message: '请选择起止点餐时间', trigger: 'change' },
                    {
                        validator: (rule, value, callback) => {
                            if (this.recipeForm.dateRange && this.recipeForm.dateRange.length > 0 && value && value.length === 2) {
                                // 允许截单日期在消费周期内，但不应该超过消费周期的最后一天晚上
                                const consumeEnd = new Date(this.recipeForm.dateRange[1] + ' 23:59:59').getTime();
                                const orderEnd = new Date(value[1]).getTime();
                                if (orderEnd > consumeEnd) {
                                    this.orderTimeError = true;
                                    return callback(new Error('订餐截止不能晚于整个消费周期的结束天'));
                                }
                            }
                            this.orderTimeError = false;
                            callback();
                        }, trigger: 'change'
                    }
                ]
            },
            orderTimeError: false,

            wizardVisible: false,
            wizardForm: {
                dateRange: [],
                selectedTimeIds: [],
                selectedDishIds: [],
                defaultQuantity: 100
            },

            timeSlotOptions: [],
            dishOptions: []
        }
    },
    computed: {
        dateTabs() {
            if (!this.recipeForm.dateRange || this.recipeForm.dateRange.length < 2) return [];
            const tabs = [];
            let start = new Date(this.recipeForm.dateRange[0]);
            let end = new Date(this.recipeForm.dateRange[1]);
            while (start <= end) {
                tabs.push(start.toISOString().substring(0, 10));
                start.setDate(start.getDate() + 1);
            }
            return tabs;
        },
        filteredDishList() {
            if (this.activeDateTab === 'all') return this.dishList;
            return this.dishList.filter(it => it.RecipeDate === this.activeDateTab);
        },
        wizardPickerOptions() {
            const start = this.recipeForm.dateRange[0] ? new Date(this.recipeForm.dateRange[0] + ' 00:00:00').getTime() : 0;
            const end = this.recipeForm.dateRange[1] ? new Date(this.recipeForm.dateRange[1] + ' 00:00:00').getTime() : 0;
            return {
                disabledDate(time) {
                    if (!start || !end) return false;
                    return time.getTime() < start || time.getTime() > end;
                }
            };
        }
    },
    watch: {
        'recipeForm.dateRange': {
            handler(val, oldVal) {
                if (val && val.length > 0) {
                    // 自动触发时间校验
                    if (this.recipeForm.orderTimeRange && this.recipeForm.orderTimeRange.length === 2) {
                        this.$nextTick(() => {
                            if (this.$refs.recipeForm) this.$refs.recipeForm.validateField('orderTimeRange');
                        });
                    }

                    // 如果是用户手动更改日期范围（而非初始化），直接清空当前的排餐明细列表
                    if (oldVal && oldVal.length > 0 && oldVal[0] !== val[0] && this.dishList && this.dishList.length > 0) {
                        this.dishList = [];
                    }
                }
            },
            deep: true
        },
        'recipeForm.orderTimeRange': {
            handler(val) {
                if (val && val.length === 2 && this.recipeForm.Id === 0) { // 仅针对新增模式
                    const endDateTime = new Date(val[1]);
                    const tomorrow = new Date(endDateTime);
                    tomorrow.setDate(endDateTime.getDate() + 1);

                    const nextWeek = new Date(tomorrow);
                    nextWeek.setDate(tomorrow.getDate() + 6);

                    const startStr = this.formatDate(tomorrow);
                    const endStr = this.formatDate(nextWeek);

                    // 仅当当前日期范围为空时自动赋值，避免用户多次操作相互覆盖
                    if (!this.recipeForm.dateRange || this.recipeForm.dateRange.length === 0) {
                        this.recipeForm.dateRange = [startStr, endStr];
                        this.recipeForm.RecipeName = startStr + ' 至 ' + endStr + ' 餐饮排餐计划';

                        // 自动触发主表单校验
                        this.$nextTick(() => {
                            if (this.$refs.recipeForm) this.$refs.recipeForm.validateField('dateRange');
                        });
                    }
                }
            }
        }
    },
    methods: {
        formatDate(date) {
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        formatTabLabel(date) {
            const d = new Date(date);
            const weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
            return `${date.substring(5)} (${weekDays[d.getDay()]})`;
        },
        getTimeTagType(name) {
            if (name.includes('早')) return 'success';
            if (name.includes('午')) return 'warning';
            if (name.includes('晚')) return 'info';
            return 'primary';
        },
        treeNodeClick(data) {
            this.departmentId = data.value;
            this.page = 1;
            this.handleSearch();
        },
        handleSearch() {
            if (!this.departmentId) return
            this.listLoading = true
            let params = {
                departmentId: this.departmentId,
                key: this.filters.date, // 这里的 filters.date 实际上作为关键词搜索
                page: this.page,
                intPageSize: this.pageSize
            }
            getDailyRecipeList(params).then(res => {
                if (res.success) {
                    this.recipeRecords = res.response.data || []
                    this.total = res.response.dataCount || 0
                }
                this.listLoading = false
            }).catch(() => {
                this.listLoading = false
            })
        },
        loadOptions() {
            if (!this.departmentId) return
            getDinnerTimeList({ departmentId: this.departmentId }).then(res => {
                if (res.data.success) this.timeSlotOptions = res.data.response || []
            })
            getDishListPage({ departmentId: this.departmentId, intPageSize: 999 }).then(res => {
                if (res.data.success) this.dishOptions = res.data.response.data || []
            })
        },
        onDishManualSelect(val) {
            const today = new Date().toISOString().substring(0, 10)
            val.forEach(id => {
                if (!this.dishList.find(it => it.dishId === id)) {
                    const dish = this.dishOptions.find(it => it.Id === id)
                    this.dishList.push({
                        dishId: id,
                        RecipeDate: this.recipeForm.dateRange[0] || today,
                        Name: dish ? dish.Name : '',
                        DinnerTimeId: '',
                        Quantity: 100,
                        Position: '',
                        DiningStartTime: '',
                        DiningEndTime: ''
                    })
                }
            })
            this.selectedDishIds = [];
        },
        onRowTimeChange(val, row) {
            const slot = this.timeSlotOptions.find(it => it.Id === val)
            if (slot) {
                row.DiningStartTime = slot.StartTime
                row.DiningEndTime = slot.EndTime
            }
        },
        removeDishFromList(index) {
            const row = this.dishList[index];
            if (row && row.OrderedQuantity > 0) {
                this.$message.error(`该菜品【${row.Name}】已有 ${row.OrderedQuantity} 份订餐，不允许移除！`);
                return;
            }
            this.dishList.splice(index, 1);
        },
        openWizard() {
            this.wizardForm = {
                dateRange: this.recipeForm.dateRange ? [...this.recipeForm.dateRange] : [],
                selectedTimeIds: [],
                selectedDishIds: [],
                defaultQuantity: 100
            }
            this.wizardVisible = true
        },
        generateByWizard() {
            if (!this.wizardForm.dateRange || !this.wizardForm.dateRange.length || !this.wizardForm.selectedTimeIds.length || !this.wizardForm.selectedDishIds.length) {
                this.$message.warning('生成信息不完整，请确认日期范围及向导内的时段、菜品均已勾选。')
                return
            }
            const dateList = []
            let start = new Date(this.wizardForm.dateRange[0])
            let end = new Date(this.wizardForm.dateRange[1])
            while (start <= end) {
                dateList.push(start.toISOString().substring(0, 10))
                start.setDate(start.getDate() + 1)
            }

            // 复制当前列表以进行操作
            const updatedDishList = [...this.dishList]

            dateList.forEach(date => {
                this.wizardForm.selectedTimeIds.forEach(timeId => {
                    const slot = this.timeSlotOptions.find(it => it.Id === timeId)
                    this.wizardForm.selectedDishIds.forEach(dishId => {
                        const dish = this.dishOptions.find(it => it.Id === dishId)
                        const newItem = {
                            dishId: dishId,
                            RecipeDate: date,
                            Name: dish ? dish.Name : '',
                            DishPrice: dish ? dish.Price : 0,
                            DinnerTimeId: timeId,
                            Quantity: this.wizardForm.defaultQuantity,
                            Position: '',
                            DiningStartTime: slot ? slot.StartTime : '',
                            DiningEndTime: slot ? slot.EndTime : ''
                        }

                        // 查找是否存在相同日期、时段、菜品
                        const existingIdx = updatedDishList.findIndex(it =>
                            it.RecipeDate === date &&
                            it.DinnerTimeId === timeId &&
                            it.dishId === dishId
                        )

                        if (existingIdx !== -1) {
                            // 覆盖旧项
                            updatedDishList.splice(existingIdx, 1, newItem)
                        } else {
                            // 新增
                            updatedDishList.push(newItem)
                        }
                    })
                })
            })
            this.dishList = updatedDishList
            this.wizardVisible = false
        },
        handleAdd() {
            if (!this.departmentId) {
                this.$message.warning('请先点击左侧树结构选择具体的机构或部门。')
                return
            }
            this.formTitle = '筹编新发布计划'

            const now = new Date();
            const todayStr = this.formatDate(now);

            // 默认消费周期：从截止日期(今天)的明天开始，持续一周
            const tomorrow = new Date();
            tomorrow.setDate(now.getDate() + 1);
            const nextWeek = new Date(tomorrow); // 基于 tomorrow 初始化，避免跨月错误
            nextWeek.setDate(tomorrow.getDate() + 6);

            const startStr = this.formatDate(tomorrow);
            const endStr = this.formatDate(nextWeek);

            this.recipeForm = {
                Id: 0,
                ReleaseId: 0,
                DepartmentId: this.departmentId,
                RecipeName: startStr + ' 至 ' + endStr + ' 餐饮排餐计划',
                dateRange: [startStr, endStr],
                orderTimeRange: [todayStr + ' 00:00:00', todayStr + ' 23:59:59']
            }
            this.dishList = []
            this.dialogVisible = true
            this.loadOptions()
        },
        handleEdit(row) {
            this.formTitle = '调整历史发布记录'
            this.recipeForm = {
                Id: row.Id,
                ReleaseId: row.Id,
                DepartmentId: this.departmentId,
                RecipeName: row.RecipeName,
                dateRange: [row.StartDate || row.RecipeDate, row.EndDate || row.RecipeDate],
                orderTimeRange: [row.OrderStartTime, row.OrderEndTime]
            }
            this.listLoading = true;
            getDailyRecipeDetail({ releaseId: row.Id }).then(res => {
                if (res.success) {
                    this.dishList = (res.response || []).map(item => ({
                        Id: item.Id,
                        dishId: item.DishId,
                        RecipeDate: item.RecipeDate,
                        Name: item.DishName,
                        DishPrice: item.DishPrice,
                        DinnerTimeId: item.DinnerTimeId,
                        Quantity: item.Quantity,
                        OrderedQuantity: item.OrderedQuantity,
                        Position: item.Position,
                        DiningStartTime: item.DiningStartTime,
                        DiningEndTime: item.DiningEndTime
                    }));
                }
                this.dialogVisible = true;
                this.listLoading = false;
                this.loadOptions();
            }).catch(() => {
                this.listLoading = false;
            });
        },
        handleSubmit() {
            this.$refs.recipeForm.validate(valid => {
                if (valid) {
                    if (!this.dishList.length) {
                        this.$message.warning('列表项不能为空，请至少编排一个供应菜品。')
                        return
                    }

                    // 时效校验
                    const endDateStr = this.recipeForm.dateRange[1];
                    const orderEndTimeStr = this.recipeForm.orderTimeRange[1];
                    const consumeEndTimestamp = new Date(endDateStr + ' 23:59:59').getTime();
                    const orderEndTimestamp = new Date(orderEndTimeStr).getTime();

                    if (consumeEndTimestamp < orderEndTimestamp) {
                        this.$message({
                            message: '逻辑冲突提醒：您的“订餐截止时间”设定在了整个“消费周期”结束之后，请修正截止时间。',
                            type: 'error',
                            duration: 5000
                        });
                        return;
                    }

                    this.submitLoading = true
                    // 构造符合 SaveDailyRecipeDto 结构的对象
                    const payload = {
                        ReleaseId: this.recipeForm.ReleaseId || 0,
                        DepartmentId: this.recipeForm.DepartmentId,
                        RecipeName: this.recipeForm.RecipeName,
                        OrderStartTime: this.recipeForm.orderTimeRange[0],
                        OrderEndTime: this.recipeForm.orderTimeRange[1],
                        StartDate: this.recipeForm.dateRange[0],
                        EndDate: this.recipeForm.dateRange[1],
                        Details: this.dishList.map(dish => ({
                            Id: dish.Id || 0,
                            DishId: dish.dishId,
                            DishPrice: dish.DishPrice || 0,
                            RecipeDate: dish.RecipeDate,
                            DinnerTimeId: dish.DinnerTimeId,
                            Quantity: dish.Quantity,
                            Position: dish.Position,
                            DiningStartTime: dish.DiningStartTime,
                            DiningEndTime: dish.DiningEndTime
                        }))
                    };

                    saveDailyRecipe(payload).then(res => {
                        if (res.success) {
                            this.$message.success('计划提交并保存成功！');
                            this.dialogVisible = false; // 确保关闭弹窗
                            this.handleSearch(); // 确保刷新列表
                        } else {
                            this.$message.error(res.msg);
                        }
                        this.submitLoading = false
                    }).catch(() => {
                        this.submitLoading = false
                    })
                }
            })
        },
        handleRemove(row) {
            this.$confirm('确认将其从当前发布计划中移除吗？', '重要提示', { type: 'warning', confirmButtonText: '确定移除' }).then(() => {
                deleteDailyRecipe({ id: row.Id }).then(res => {
                    if (res.success) {
                        this.$message.success('已从计划中剥离该项记录。')
                        this.handleSearch()
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            }).catch(() => { })
        },
        handleSizeChange(val) { this.pageSize = val; this.handleSearch(); },
        handleCurrentChange(val) { this.page = val; this.handleSearch(); }
    }
}
</script>

<style scoped>
/* 极致视觉系统设计：修正版 */
.glass-header {
    background: #fff;
    padding: 12px 20px;
    margin-bottom: 12px;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f1f5f9;
}

.title-group h1 {
    font-size: 18px;
    font-weight: 800;
    color: #1e293b;
    margin: 0;
}

.subtitle {
    font-size: 12px;
    color: #64748b;
    margin-top: 2px;
}


/* 表格视觉优化 */
.modern-table {
    border: none !important;
}

.date-badge {
    background: #f0f9ff;
    color: #0284c7;
    padding: 2px 6px;
    border-radius: 4px;
    font-weight: 600;
    font-size: 12px;
}

.task-name {
    font-weight: 700;
    color: #334155;
    font-size: 13px;
}

.task-range {
    font-size: 11px;
    color: #94a3b8;
}

.dish-name-text {
    font-weight: 700;
    color: #334155;
}

.price-text {
    color: #dc2626;
    font-weight: 700;
    font-size: 14px;
}

/* 弹窗视觉体系 */
.aesthetic-dialog {
    border-radius: 16px !important;
}

.config-grid {
    display: grid;
    grid-template-columns: 1.2fr 1fr;
    gap: 15px;
}

.config-card {
    background: #fafafa;
    padding: 15px;
    border-radius: 12px;
    border: 1px solid #f1f5f9;
}

.card-title {
    font-size: 14px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.card-title::before {
    content: '';
    width: 3px;
    height: 12px;
    background: #3b82f6;
    border-radius: 2px;
}

.wizard-container {
    background: #fff;
    border: 1px solid #f1f5f9;
    border-radius: 12px;
    padding: 15px;
}

.wizard-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.wizard-header h3 {
    font-size: 14px;
    font-weight: 700;
    margin: 0;
}

.wizard-header p {
    font-size: 11px;
    color: #94a3b8;
    margin: 2px 0 0;
}

.matrix-table-wrapper {
    border: 1px solid #f1f5f9;
    border-radius: 8px;
    overflow: hidden;
}

.matrix-footer {
    background: #f8fafc;
    padding: 8px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
}

.stats-text b {
    color: #3b82f6;
}

.empty-matrix {
    padding: 40px 0;
    text-align: center;
    background: #fcfcfc;
    border: 1px dashed #e2e8f0;
    border-radius: 8px;
}

.empty-matrix i {
    font-size: 32px;
    color: #cbd5e1;
}

.empty-matrix p {
    color: #94a3b8;
    font-size: 12px;
    margin-top: 8px;
}

/* 向导布局修正项 */
.wizard-modal /deep/ .el-dialog__body {
    padding: 20px 30px;
}

.wizard-section {
    background: #fff;
}

.wizard-label {
    font-size: 13px;
    font-weight: 700;
    color: #334155;
    margin: 0 0 10px 0;
    display: flex;
    align-items: center;
    gap: 8px;
}

.wizard-label i {
    color: #3b82f6;
}

/* 修正 Checkbox 布局错位 */
.wizard-checkbox-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.wizard-checkbox-grid .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
}

.wizard-checkbox-grid .el-checkbox {
    margin: 0 !important;
    display: flex !important;
    align-items: center;
}

.gradient-btn-primary {
    background: #3b82f6 !important;
    border-color: #3b82f6 !important;
    color: #fff !important;
    font-weight: 600;
}

.gradient-btn-primary:hover {
    background: #2563eb !important;
    opacity: 0.9;
}

.w-full {
    width: 100%;
}

.m-0 {
    margin: 0;
}

.mb-5 {
    margin-bottom: 5px;
}

.mr-10 {
    margin-right: 10px;
}

.mt-15 {
    margin-top: 15px;
}

.mt-20 {
    margin-top: 20px;
}

.mx-2 {
    margin: 0 2px;
}

.px-30 {
    padding-left: 30px !important;
    padding-right: 30px !important;
}

.text-right {
    text-align: right;
}

.text-danger {
    color: #ef4444;
}

.shadow-sm {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.shadow-lg {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.wizard-info-badge {
    background: #f8fafc;
    padding: 12px 15px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    font-weight: 700;
    color: #3b82f6;
    font-family: monospace;
}

.read-only-time {
    color: #64748b;
    font-weight: 600;
    font-size: 13px;
    white-space: nowrap;
}

.read-only-time i {
    color: #94a3b8;
}

.matrix-tabs-bar {
    background: #f8fafc;
    border-bottom: 1px solid #f1f5f9;
}

.modern-tabs /deep/ .el-tabs__header {
    margin: 0 !important;
    border-bottom: none !important;
}

.modern-tabs /deep/ .el-tabs__nav {
    border: none !important;
}

.modern-tabs /deep/ .el-tabs__item {
    border: none !important;
    font-size: 13px;
    height: 40px;
    line-height: 40px;
    color: #64748b;
    transition: all 0.3s;
}

.modern-tabs /deep/ .el-tabs__item.is-active {
    background: #fff;
    color: #3b82f6;
    font-weight: 700;
}


.wizard-logic-tip {
    font-size: 11px;
    color: #3b82f6;
    background: #eff6ff;
    padding: 4px 8px;
    border-radius: 4px;
}

.date-range-text {
    font-family: 'Monaco', 'Courier New', monospace;
    color: #475569;
    font-weight: 600;
}

.time-range-display {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.range-sep {
    color: #94a3b8;
    font-size: 12px;
}
</style>
